import React from 'react';
import './VisionMission.css';

const VisionMission = ({ language }) => {
  const translations = {
    en: {
      vision: 'VISION',
      visionText: 'To be the most trusted partner for organizations worldwide, delivering innovative solutions that ensure operational excellence, efficiency, and sustainable growth through cutting-edge technology and exceptional service.',
      mission: 'MISSION',
      missionText: 'Provide comprehensive, secure, and intelligent solutions that streamline operations for organizations of all types and sizes, ensuring reliability, innovation, and exceptional service excellence.',
    },
    ar: {
      vision: 'الرؤية',
      visionText: 'أن نكون الشريك الموثوق للمؤسسات، ونوفر حلول مبتكرة تضمن التميز التشغيلي والكفاءة والنمو المستدام من خلال التكنولوجيا المتقدمة والخدمة المتميزة',
      mission: 'المهمة',
      missionText: 'تقديم حلول شاملة وآمنة وذكية تبسط العمليات للمؤسسات من جميع الأنواع والأحجام، مما يضمن الموثوقية والابتكار وتميز الخدمة',
    },
  };

  const t = translations[language];

  return (
    <section className="vision-mission" id="about">
      <div className="vision-mission-container">
        <div className="card">
          <div className="card-icon">🎯</div>
          <h3>{t.vision}</h3>
          <p>{t.visionText}</p>
        </div>
        <div className="card">
          <div className="card-icon">⚙️</div>
          <h3>{t.mission}</h3>
          <p>{t.missionText}</p>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
